import React, { useState, useCallback, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useReactToPrint } from 'react-to-print';
import { FormattedMessage } from 'react-intl';

import { useParams } from 'react-router-dom';

import styled from 'styled-components';
import Loading from '@/components/Form/Loading';
import { FormError } from 'UIKit/Fonts';
import { Box, Flex } from 'UIKit/Grid';

import Modal from '@/components/Modal';
import RenderCustomField from '@/components/Form/Input/RenderCustomField';

import GratitudeImg from 'assets/img/gratitude_ru.jpg';

import {
  fetchParticipant,
  REQUEST_GET_PARTICIPANT,
  // REQUEST_GET_OLIMPIC,
  categories,
} from '@/modules/Olimpic';
import ColorLink from '@/components/UIKit/ColorLink';
import StyledButton from 'sama_global/components/StyledButton';

const PrintWrap = styled.div`
  width: 840px;
  height: 1188px; // пропорции листа А4
  position: relative;
  font-family: arial;
  font-size: 24px;
  text-shadow: 1px 0 0 white, 0 1px 0 white, -1px 0 0 white, 0 -1px 0 white;

  @media print {
    @page {
      margin: 20px;
    }

    font-size: 22px;
    width: 100%;
    align-items: center;
    display: flex;
    height: 100%;
  }
`;

// const TextName = styled.div`
//   position: absolute;
//   bottom: 52%;
//   text-align: center;
//   font-size: 150%;
//   width: 100%;
//   padding: 0 100px;
//   text-transform: uppercase;
//   transform: translateY(50%);
// `;
// const TextPlace = styled.div`
//   position: absolute;
//   bottom: 64%;
//   width: 100%;
//   text-align: center;
//   font-size: 170%;
//   font-weight: bold;
//   text-transform: uppercase;
// `;
// const TextPlace2 = styled.div`
//   position: absolute;
//   bottom: 45%;
//   left: 24%;
//   text-align: center;
//   font-weight: bold;
//   text-transform: lowercase;
// `;
// const TextCategory = styled.div`
//   position: absolute;
//   bottom: 45%;
//   left: 65%;
//   text-align: center;
//   font-weight: bold;
// `;
// const TextDesc = styled.div`
//   position: absolute;
//   top: 70%;
//   transform: translateY(-50%);
//   text-align: center;
//   line-height: 130%;
//   white-space: pre-wrap;
//   padding: 0 100px;
//   width: 100%;
// `;
// const CenterDiplomText1 = styled.div`
//   position: absolute;
//   top: 46.5%;
//   display: flex;
//   align-items: center;
//   text-align: center;
//   justify-content: center;
//   font-weight: bold;
//   padding: 0 130px;
//   width: 100%;
//   height: 13%;
// `;
// const TeacherDiplomText1 = styled.div`
//   position: absolute;
//   top: 46.5%;
//   display: flex;
//   align-items: center;
//   text-align: center;
//   justify-content: center;
//   font-weight: bold;
//   padding: 0 130px;
//   width: 100%;
//   height: 13%;
// `;

const RenderPlace = ({ participant: { place }, lang, by }) =>
  ({
    [+place === 0]:
      lang === 'en' ? (
        <FormattedMessage id="CHAMPION_EN" defaultMessage="" />
      ) : (
        <>
          <FormattedMessage id="CHAMPION" defaultMessage="" />
          {by && 'ом'}
        </>
      ),
    [+place > 3]:
      lang === 'en' ? (
        <FormattedMessage id="COMPETITOR_EN" defaultMessage="" />
      ) : (
        <>
          <FormattedMessage id="COMPETITOR" defaultMessage="" />
          {by && 'ом'}
        </>
      ),
    [+place >= 1 && +place <= 3]:
      lang === 'en' ? (
        <>
          {place}
          {['', '-st ', '-nd', '-rd'][+place]}
          {' place'}
        </>
      ) : (
        <>{by ? `призёром` : `${place} место`}</>
      ),
  }.true);

RenderPlace.propTypes = {
  lang: PropTypes.string.isRequired,
  participant: PropTypes.object,
  by: PropTypes.bool,
};

RenderPlace.defaultProps = {
  by: false,
  participant: null,
};

const PrintDiplom = React.forwardRef((props, ref) => {
  const { mode, participant, olimpic, lang, text } = props;

  const categoryInfo = categories[participant?.category] || {};
  const [lil, big] = categoryInfo.year || [];
  if (!olimpic) return <></>;

  return (
    <PrintWrap ref={ref}>
      {
        {
          personal: (
            <>
              {participant && (
                <div style={{ position: 'relative', minHeight: 900 }}>
                  <img
                    src={lang === 'en' ? olimpic.diplom_en : olimpic.diplom_ru}
                    alt=""
                  />

                  <div>
                    <RenderPlace participant={participant} lang={lang} />
                  </div>

                  <div>
                    {lang === 'en'
                      ? `${
                          participant.user.surname_en
                            ? participant.user.surname_en
                            : ''
                        } 
                           ${
                             participant.user.name_en
                               ? participant.user.name_en
                               : ''
                           } 
                           ${
                             participant.user.patronymic_en
                               ? participant.user.patronymic_en
                               : ''
                           }`
                      : `${participant.user.surname} ${
                          participant.user.name
                        } ${participant.user.patronymic || ''}`}
                  </div>

                  <div>
                    <RenderPlace participant={participant} lang={lang} by />
                  </div>

                  <div>
                    {participant.category}{' '}
                    {categoryInfo.year && (
                      <>
                        (
                        {!big && (
                          <>
                            {!participant.category?.includes('A') ? (
                              <>
                                {lang === 'en' ? (
                                  'after'
                                ) : (
                                  <FormattedMessage
                                    id="AFTER"
                                    defaultMessage=""
                                  />
                                )}{' '}
                              </>
                            ) : (
                              <>
                                {lang === 'en' ? (
                                  'before'
                                ) : (
                                  <FormattedMessage
                                    id="over"
                                    defaultMessage=""
                                  />
                                )}{' '}
                              </>
                            )}{' '}
                          </>
                        )}
                        {lil}
                        {big && `-${big}`}
                        {lang === 'en' ? 'year' : 'г.'})
                      </>
                    )}
                  </div>

                  <div>{categoryInfo[`${lang}2`]}</div>
                </div>
              )}
            </>
          ),
          center: (
            <div style={{ position: 'relative' }}>
              <img
                src={
                  olimpic && olimpic.gratitude_ru
                    ? olimpic.gratitude_ru
                    : GratitudeImg
                }
                alt=""
              />
              <div>{text}</div>
            </div>
          ),
          teacher: (
            <div style={{ position: 'relative' }}>
              <img
                src={
                  olimpic && olimpic.gratitude_ru
                    ? olimpic.gratitude_ru
                    : GratitudeImg
                }
                alt=""
              />
              <div>{text}</div>
            </div>
          ),
        }[mode]
      }
    </PrintWrap>
  );
});

PrintDiplom.propTypes = {
  text: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  participant: PropTypes.string.isRequired,
  olimpic: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
};

const Diploma = ({ requests, olimpic, getParticipant }) => {
  const { mode, lang, id } = useParams();
  const [text, setText] = useState('');
  const [show, setShow] = useState(false);
  const componentRef = useRef(null);

  const reactToPrintContent = useCallback(() => componentRef.current, [
    componentRef.current,
  ]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (mode === 'personal') getParticipant(id);
  }, []);

  const request = requests[REQUEST_GET_PARTICIPANT];
  // const lang = 'ru';
  const user = request?.data?.user || {};

  return (
    <>
      <Modal show={show} close={() => setShow(false)}>
        <Flex flexDirection="column" alignItems="center">
          <Box mb={6} maxWidth={400} textAlign="center">
            <FormattedMessage id="ENTER_TEXT" defaultMessage="" />
          </Box>
          <Box>
            <RenderCustomField
              meta={{}}
              input={{
                onChange: e => setText(e.currentTarget.value),
                value: text,
              }}
            />
          </Box>
          <Flex mt={9}>
            <StyledButton variant="contained" onClick={() => setShow(false)}>
              <FormattedMessage id="CHANGE_TEXT" defaultMessage="" />
            </StyledButton>
          </Flex>
        </Flex>
      </Modal>
      <Box>
        {request && (
          <>
            {request.loading && <Loading />}
            {request.error && <FormError>{request.errorMessage}</FormError>}
          </>
        )}
        {lang === 'en' && !(user.surname_en && user.name_en) && (
          <FormError>
            To display correctly, fill in the surname and first name in English
            in{' '}
            <ColorLink color="#ecffa4" to="/profile/edit">
              profile editing
            </ColorLink>
          </FormError>
        )}
        <Flex p={5}>
          <Box mr={4}>
            <StyledButton variant="contained" onClick={handlePrint}>
              <FormattedMessage id="TO_PRINT" defaultMessage="" />
            </StyledButton>
          </Box>
          {mode !== 'personal' && (
            <StyledButton variant="contained" onClick={() => setShow(true)}>
              <FormattedMessage id="CHANGE_TEXT" defaultMessage="" />
            </StyledButton>
          )}
        </Flex>
        <Flex p={5}>
          <PrintDiplom
            mode={mode}
            participant={request?.data}
            olimpic={olimpic}
            lang={lang}
            ref={componentRef}
            text={text}
          />
        </Flex>
      </Box>
    </>
  );
};

Diploma.propTypes = {
  requests: PropTypes.object.isRequired,
  olimpic: PropTypes.object.isRequired,
  getParticipant: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  requests: state.requests,
  olimpic: state.olimpic.online,
});

const mapDispatchToProps = dispatch => ({
  getParticipant(id) {
    dispatch(fetchParticipant(id));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Diploma);
